import React, { useEffect, useState } from 'react';
import { useSaga } from 'use-reducer-saga';
import reducer, { initialState } from './localStore/reducer';
import sagas from './localStore/sagas';
import { verifyInviteTokenStart } from './localStore/actions';
import { UnAuthenticatedPageLayout } from 'layouts/unAuthenticatedPage.layout';
import { useLocation } from 'react-router-dom';
import { useComponentMount } from 'utilities/hooks.util';
import { InlineNotification, Loading } from 'carbon-components-react';
import createUrlBuilder from 'utilities/url.builder.utils';

const { REACT_APP_IDENTITY_WEB_URL, REACT_APP_IDENTITY_LOCATE_CLIENTID } =
  process.env;

export const Welcome: React.FC = () => {
  const [noticeText, setNoticeText] = useState<string>(
    'Welcome to SmarterWX Locate. Please wait while we verify your profile'
  );
  const [isError, setIsError] = useState<boolean>(false);
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const { verification, error } = localStore;
  const location = useLocation<{ from?: string }>();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (verification === 'success') {
      const urlBuilder = createUrlBuilder(
        `${REACT_APP_IDENTITY_WEB_URL}/login`
      );
      REACT_APP_IDENTITY_LOCATE_CLIENTID &&
        urlBuilder.addParameter('clientId', REACT_APP_IDENTITY_LOCATE_CLIENTID);

      window.location.href = urlBuilder.toString();
    }
  }, [verification]);

  useEffect(() => {
    if (error) {
      setIsError(true);
      setNoticeText(error);
    }
  }, [error]);

  useComponentMount(() => {
    const inviteToken = queryParams.get('invitetoken');
    if (inviteToken) {
      localDispatch(verifyInviteTokenStart(inviteToken));
    } else {
      setIsError(true);
      setNoticeText('Invalid invitation detail');
    }
  });

  return (
    <div id="Welcome" className="welcome">
      <UnAuthenticatedPageLayout enableHeaderGlobalBar={false}>
        <InlineNotification
          kind={isError ? 'error' : 'info'}
          title={noticeText}
          lowContrast={true}
          hideCloseButton={true}
        />
        {verification === 'verifying' && (
          <div className="loading-container">
            <Loading withOverlay={false} />
          </div>
        )}
      </UnAuthenticatedPageLayout>
    </div>
  );
};

Welcome.displayName = 'Welcome';

export default React.memo(Welcome);
